import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useLazyGetTagsQuery } from 'src/features/admin/tagging/tagging.slice';
import type { Tag, TagFormData } from 'src/features/admin/tagging/tagging.types';

export const useTagFormResolver = (defaultValues?: TagFormData) => {
  const [trigger] = useLazyGetTagsQuery();
  return yupResolver(
    yup.object({
      label: yup
        .string()
        .required()
        .test('label', 'Tag with this label already exists', async (value) => {
          if (value === defaultValues?.label) {
            return true;
          }
          if (value) {
            const partiallyMatchedTagsResp = await trigger({
              category: undefined,
              subcategory: undefined,
              populate: false,
              label: value,
            }).unwrap();
            return !partiallyMatchedTagsResp.tags.map((t: Tag) => t.label).includes(value);
          }
          return false;
        }),
      category: yup.object().shape({
        value: yup.string().required(),
      }),
    }),
  );
};
